import Vue from "vue";
import app from "@/main";
import { AuthService } from "@/services";

const actions = {
    // LOGIN
  async login({commit}, { email, password }) {
    const { data } = await AuthService.login({ email, password });
    await commit("storeUser", data.user, {root: true})
    AuthService.authenticateUser(data.token);
  },

  // RECOVER PASSWORD 
  async recover(context, {email}){
    const { message } = await AuthService.recover({ email });
    app.$store.dispatch('toast',{
      message:message,
      variant: 'success'
    })
    localStorage.setItem('email',email)
    app.$router.push("/reset-password")
  },

  // RESET PASSWORD
  async reset(context, { email, otp, password, cpassword}){
    const { message } = await AuthService.reset({
      email,
      otp,
      password,
      cpassword
    });
    app.$store.dispatch('toast', {
      message: message,
      variant:'success'
    })
    localStorage.removeItem('email');
    app.$router.push("/login")
  },

  // LOGOUT
  async logout({ commit }) {
    let user = null
    commit("removeUser", user, { root: true });
    // localStorage.clear();  
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('access');
  },
  
  // VERIFY 2FA
  async verify2FA({ commit }, { token }){
    const { data, message } = await AuthService.verify2FA({ token });
    await commit("storeUser", data.user, {root: true})
    await AuthService.authenticateUser(data.token);
    app.$store.dispatch('toast', {
      message: message,
      variant: 'success'
    })
    const userPermissions = app.$store.state.userDetails.permissions;
    Vue.mixin({
      methods: {
        can: (key) => userPermissions.includes(key) || !key
      }
    })
    app.$router.push("/dashboard");
  },
};

export default {
    namespaced: true,
    actions,
  };
  